export function familyProfilePath() {
  return '/family/profile'
}
